import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_VOICEOVER_AVATAR_ID, getVoiceoverAvatar, VoiceoverAvatarId } from '@/config/voiceoverAvatars';

interface VoiceoverState {
  isVoiceoverEnabled: boolean;
  voiceoverVolume: number;
  selectedAvatarId: VoiceoverAvatarId;
  selectedVoiceURI: string;
  selectedVoiceName: string;
  selectedVoiceLang: string;
  setVoiceoverVolume: (volume: number) => void;
  setSelectedAvatar: (avatarId: VoiceoverAvatarId) => void;
  setSelectedVoice: (voice: { voiceURI: string; name: string; lang: string } | null) => void;
  toggleVoiceover: () => void;
}

const clampVolume = (volume: number) => Math.min(1, Math.max(0, volume));

export const useVoiceoverStore = create<VoiceoverState>()(
  persist(
    (set) => ({
      isVoiceoverEnabled: true,
      voiceoverVolume: 1,
      selectedAvatarId: DEFAULT_VOICEOVER_AVATAR_ID,
      selectedVoiceURI: '',
      selectedVoiceName: '',
      selectedVoiceLang: '',
      setVoiceoverVolume: (volume) => set({
        voiceoverVolume: clampVolume(volume),
      }),
      setSelectedAvatar: (avatarId) => set({
        selectedAvatarId: getVoiceoverAvatar(avatarId).id,
      }),
      setSelectedVoice: (voice) => set({
        selectedVoiceURI: voice?.voiceURI || '',
        selectedVoiceName: voice?.name || '',
        selectedVoiceLang: voice?.lang || '',
      }),
      toggleVoiceover: () => set((state) => ({ isVoiceoverEnabled: !state.isVoiceoverEnabled })),
    }),
    {
      name: 'voiceover-storage',
    }
  )
);
